import presetsServices from '../../services/pos/presets';

export const FETCH_PRESETS = 'FETCH_PRESETS';
export const FETCH_PRESETS_SUCCESS = 'FETCH_PRESETS_SUCCESS';
export const FETCH_PRESETS_ERROR = 'FETCH_PRESETS_ERROR';

export const getPresets = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_PRESETS });
  try {
    const presets = await presetsServices.getAllPresets();
    dispatch({ type: FETCH_PRESETS_SUCCESS, payload: presets });
  } catch (error) {
    dispatch({ type: FETCH_PRESETS_ERROR });
  }
};
